const PROFILE_CACHE_KEY = 'restaurant_panel_profile';

export function readCachedProfile() {
    try {
        const raw = sessionStorage.getItem(PROFILE_CACHE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function writeCachedProfile(payload) {
    try {
        if (payload?.data) {
            sessionStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify(payload));
        }
    } catch {
        // ignore quota / private mode
    }
}

export function clearCachedProfile() {
    try {
        sessionStorage.removeItem(PROFILE_CACHE_KEY);
    } catch {
        // ignore
    }
}

export function buildProfilePayload({name, is_open, is_accepting_orders, within_working_hours, order = 0}) {
    return {
        data: {
            name: name ?? null,
            is_open: typeof is_open === 'boolean' ? is_open : is_open === 1 || is_open === '1',
            is_accepting_orders: typeof is_accepting_orders === 'boolean'
                ? is_accepting_orders
                : is_accepting_orders === 1 || is_accepting_orders === '1',
            within_working_hours: typeof within_working_hours === 'boolean'
                ? within_working_hours
                : within_working_hours === 1 || within_working_hours === '1',
            order: order ? 1 : 0,
        },
    };
}
